export const MODAL_SETTINGS = "MODAL_SETTINGS";

export const OPEN_MODAL = "OPEN_MODAL";
export const CLOSE_MODAL = "CLOSE_MODAL";
